module.exports = __webpack_public_path__ + "img/Bpoint1.1d40aafe.png";